import { render, staticRenderFns } from "./TaxGroupsSelector.vue?vue&type=template&id=1f990e6e"
import script from "./TaxGroupsSelector.vue?vue&type=script&lang=js"
export * from "./TaxGroupsSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports